var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("network-list"+_vm._s(_vm.a))])
}
var staticRenderFns = []

export { render, staticRenderFns }